import React from 'react';
import { quartosMock } from './mock';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';

export default function Quartos() {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Quarto</TableCell>
            <TableCell>Tipo</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Diária</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {quartosMock.map((q) => (
            <TableRow key={q.numero} hover>
              <TableCell>{q.numero}</TableCell>
              <TableCell>{q.tipo}</TableCell>
              <TableCell>
                <Chip size="small" label={q.status} color={q.status === 'Livre' ? 'success' : q.status === 'Ocupado' ? 'warning' : 'default'} />
              </TableCell>
              <TableCell align="right">{q.diaria.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
